var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "edit-form" },
    [
      _c(
        "a-form-model",
        { attrs: { layout: _vm.layout, model: _vm.formState } },
        [
          _c("a-form-model-item", { attrs: { label: "字段1：" } }, [
            _vm._v(" " + _vm._s(_vm.formState.field1) + " "),
          ]),
          _c("a-form-model-item", { attrs: { label: "字段2：" } }, [
            _vm._v(" " + _vm._s(_vm.formState.field2) + " "),
          ]),
          _c("a-form-model-item", { attrs: { label: "字段3：" } }, [
            _vm._v(" " + _vm._s(_vm.formState.field3) + " "),
          ]),
          _c("a-form-model-item", { attrs: { label: "字段4：" } }, [
            _vm._v(" " + _vm._s(_vm.formState.field4) + " "),
          ]),
          _c("a-form-model-item", { attrs: { label: "字段5：" } }, [
            _vm._v(" " + _vm._s(_vm.formState.field5) + " "),
          ]),
          _c("a-form-model-item", { attrs: { label: "字段6：" } }, [
            _vm._v(" " + _vm._s(_vm.formState.field6) + " "),
          ]),
          _c("a-form-model-item", { attrs: { label: "字段7：" } }, [
            _vm._v(" " + _vm._s(_vm.formState.field7) + " "),
          ]),
          _c("a-form-model-item", { attrs: { label: "字段8：" } }, [
            _vm._v(" " + _vm._s(_vm.formState.field8) + " "),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }